"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var config_1 = require("../config");
var next_1 = require("@alifd/next");
var react_1 = require("react");
var task_1 = require("@alife/task");
var contextManage_1 = require("../contextManage");
var scan_image_1 = require("../static/images/scan-image");
var QrCodeLogin = function (props) {
    var context = react_1.useContext(contextManage_1.DeviceTaskContext);
    react_1.useEffect(function () {
        if (context.progress === config_1.PROCESS.success) {
            var data = JSON.parse(context.taskResult.list[0].result);
            task_1.GovCookie.personSet({
                psid: data.userInfo.userId,
                username: data.userInfo.userName,
                type: "legal",
            });
            context.setGotoHost(data.ssoUrl);
            context.clear();
            context.success(context.taskResult);
        }
    }, [context.progress]);
    if (context.progress === config_1.PROCESS.pending) {
        return (React.createElement("div", null,
            React.createElement("div", { className: "status", key: 1 }, "\u4EFB\u52A1\u53D1\u9001\u4E2D\uFF0C\u8BF7\u7A0D\u540E"),
            React.createElement("div", { className: "payload", key: 2 },
                React.createElement("img", { src: scan_image_1.default })),
            React.createElement("div", { className: "center" },
                React.createElement(next_1.Button, { type: "primary", onClick: function () { context.closeDialog(); } }, "\u53D6\u6D88"))));
    }
    else if (context.progress === config_1.PROCESS.processing) {
        // 签名任务
        return (React.createElement("div", null,
            React.createElement("div", { className: "status", key: 1 },
                React.createElement("span", null, "\u8BF7\u63D0\u9192\u529E\u4E8B\u4EBA\u4F7F\u7528\u6D59\u91CC\u529E\u767B\u5F55\u6CD5\u4EBA\u8D26\u53F7\uFF0C\u7136\u540E\u626B\u4E00\u626BPad\u4E0A\u7684\u4E8C\u7EF4\u7801"),
                React.createElement("span", { className: "btnLink", style: { fontSize: "16px", marginLeft: "5px" }, onClick: function () { context.setStatus(config_1.TASKTYPE.manualLogin); } }, "\u7EBF\u4E0B\u9A8C\u8BC1")),
            React.createElement("div", { className: "payload", key: 2 },
                React.createElement("img", { src: scan_image_1.default })),
            React.createElement("div", { className: "center" },
                React.createElement(next_1.Button, { type: "primary", onClick: function () { context.closeDialog(); } }, "\u53D6\u6D88"))));
    }
    else if (context.progress === config_1.PROCESS.success) {
        return (React.createElement("div", null,
            React.createElement("div", { className: "status2", key: 1 }, "\u6CD5\u4EBA\u767B\u5F55\u6210\u529F"),
            React.createElement("div", { className: "payload", key: 2 },
                React.createElement("img", { src: scan_image_1.default }))));
    }
    return React.createElement("div", null);
};
exports.default = QrCodeLogin;
